// removed by extract-text-webpack-plugin
module.exports = {"taskTemplateBlockView":"TaskTemplateBlockView__taskTemplateBlockView__2U5PV","overviewHeader":"TaskTemplateBlockView__overviewHeader__ZOZJx","list":"TaskTemplateBlockView__list__1DyvP"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockView/TaskTemplateBlockView.scss
// module id = 1871
// module chunks = 0